import script from "./LeaderRequestViewForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderRequestViewForm.vue?vue&type=script&setup=true&lang=js"

import "./LeaderRequestViewForm.vue?vue&type=style&index=0&id=dc6db062&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc6db062"]])

export default __exports__